import LandingDcV2Page from "@/components/landing/dcv2";

/**
 * Route host for the homepage.
 *
 * The font and stylesheet injection that used to live here moved into DcPage,
 * so every page built on the v2 design language gets it rather than only this
 * one. Nothing is left for the route to do.
 */
export default function LandingDcV2() {
  return <LandingDcV2Page />;
}
